import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import { GuideOverlayProps } from './types';
import { useLanguage } from '@/contexts/LanguageContext';
import {
  GuideOverlayContainer,
  Mask,
  GuideWindow,
  GuideContent,
  GuideHeader,
  GuideFooter,
  CloseButton,
  GuideImage,
  GuideImageContainer,
  GuideIndicator,
  IndicatorIcon,
  IndicatorText,
  IndicatorImage,
  IndicatorTextContainer,
} from './styles';
import AlarmSvg from '@/assets/icons/alarm.svg';

const GuideOverlay: React.FC<GuideOverlayProps> = ({
  visible = false,
  steps = [],
  currentStep = 0,
  onClose,
  onNext,
  onComplete,
  showCloseButton = true,
  showNavigation = true,
  className = '',
  style = {},
}) => {
  const { t } = useLanguage();
  const [internalCurrentStep, setInternalCurrentStep] = useState(currentStep);
  const guideWindowRef = useRef<HTMLDivElement>(null);

  // 同步外部传入的 currentStep
  useEffect(() => {
    setInternalCurrentStep(currentStep);
  }, [currentStep]);

  // 获取当前步骤
  const currentStepData = steps[internalCurrentStep];
  const isLastStep = internalCurrentStep === steps.length - 1;

  // 处理下一步
  const handleNext = () => {
    if (isLastStep) {
      onComplete?.();
    } else {
      const nextStep = internalCurrentStep + 1;
      setInternalCurrentStep(nextStep);
      onNext?.(nextStep);
    }
  };

  // 处理上一步（暂时注释掉，因为当前UI不需要）
  // const handlePrev = () => {
  //   if (!isFirstStep) {
  //     const prevStep = internalCurrentStep - 1;
  //     setInternalCurrentStep(prevStep);
  //     onPrev?.(prevStep);
  //   }
  // };

  // 处理关闭
  const handleClose = () => {
    onClose?.();
  };

  if (!visible || !currentStepData) {
    return null;
  }

  // 计算引导窗口位置，用于指示器定位
  const guidePosition = {
    top: typeof currentStepData.top === 'number' ? currentStepData.top : 300,
    left: typeof currentStepData.left === 'number' ? currentStepData.left : 500,
  };

  return (
    <GuideOverlayContainer className={className} style={style}>
      <Mask />

      {/* 位置指示器 */}
      {currentStepData.indicator?.show && (
        <GuideIndicator
          position={currentStepData.indicator.position || 'left'}
          guidePosition={guidePosition}
          style={currentStepData.indicator.style}
        >
          {currentStepData.indicator.icon && (
            <IndicatorIcon>{currentStepData.indicator.icon}</IndicatorIcon>
          )}
          {currentStepData.indicator.text && (
            <IndicatorTextContainer>
              <IndicatorText style={currentStepData.indicator.style}>
                {currentStepData.indicator.text}
              </IndicatorText>
            </IndicatorTextContainer>
          )}
          {currentStepData.indicator.image && (
            <IndicatorImage>
              <img src={currentStepData.indicator.image} alt={currentStepData.indicator.text} />
            </IndicatorImage>
          )}
        </GuideIndicator>
      )}

      <GuideWindow
        ref={guideWindowRef}
        customTop={currentStepData.top}
        customLeft={currentStepData.left}
      >
        <GuideContent>
          {/* {showCloseButton && (
            <CloseButton onClick={handleClose}>
              <CloseOutlined />
            </CloseButton>
          )} */}

          <GuideHeader>
            {currentStepData.title && (
              <div>
                <img src={AlarmSvg} style={{ width: '20px', height: '20px' }} />
                {currentStepData.title}
              </div>
            )}
          </GuideHeader>

          <GuideImageContainer>
            {currentStepData.image && (
              <GuideImage
                src={currentStepData.image}
                alt={currentStepData.imageAlt || currentStepData.title || '引导图片'}
                style={currentStepData.imageStyle}
              />
            )}
          </GuideImageContainer>

          {currentStepData.content && (
            <div style={{ padding: '0 24px 24px', color: '#ccc', lineHeight: '1.6' }}>
              {currentStepData.content}
            </div>
          )}
          {/* 多引导显示步骤 */}
          {/* {showStepIndicator && steps.length > 1 && (
            <StepIndicator>
              {steps.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: index === internalCurrentStep ? '#FF6A39' : 'rgba(255, 255, 255, 0.3)',
                    transition: 'background-color 0.3s ease',
                  }}
                />
              ))}
            </StepIndicator>
          )} */}

          {showNavigation && (
            <GuideFooter>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* <div style={{ display: 'flex', gap: '8px' }}>
                  {!isFirstStep && (
                    <NavigationButton onClick={handlePrev}>
                      <LeftOutlined />
                      上一步
                    </NavigationButton>
                  )}
                </div> */}

                {/* <Button
                    type="text"
                    onClick={handleClose}
                    style={{ color: '#999' }}
                  >
                    跳过
                  </Button> */}
                <Button
                  type="primary"
                  onClick={handleNext}
                  style={{
                    width: '100%',
                    borderRadius: '10px',
                    height: '28px',
                    fontSize: '14px',
                    color: '#fff',
                    background: 'linear-gradient(122.95deg, #FEAE45 19.66%, #FF6D49 67.36%)',
                  }}
                >
                  {isLastStep ? t('guide.gotIt') : t('guide.nextStep')}
                  {!isLastStep && <RightOutlined />}
                </Button>
              </div>
            </GuideFooter>
          )}
        </GuideContent>
      </GuideWindow>
    </GuideOverlayContainer>
  );
};

export default GuideOverlay;
